var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{on:{"!click":function($event){return _vm.onCaptureClick.apply(null, arguments)}}},[_c('JoszakiButton',{attrs:{"type":"success","icon-left":"chevron-right","icon-left-pack":"fas","size":"lg","disabled":_vm.disabled},on:{"click":function($event){return _vm.$emit('click', $event)}}},[_vm._v(" "+_vm._s(_vm.$t("requestTender.next"))+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }